// One look for every sidebar entry (Dashboard link, group headers, items, icon rail), for every role.

const ACTIVE_BG = "rgba(25, 118, 210, 0.08)";
const ACTIVE_BG_HOVER = "rgba(25, 118, 210, 0.12)";
const HOVER_BG = "#f1f5f9";
const INK = "#334155";
const ICON = "#64748b";

/** A clickable row: Dashboard, group header and item links all share it. */
export const menuRowSx = {
  mx: 1,
  my: 0.25,
  px: 1.5,
  minHeight: 40,
  borderRadius: 2,
  color: INK,
  "& .MuiListItemIcon-root": { minWidth: 36, color: ICON },
  "& .MuiSvgIcon-root": { fontSize: 20 },
  "& .MuiListItemText-primary": { fontSize: 14, fontWeight: 500 },
  "&:hover": { bgcolor: HOVER_BG },
  "&.Mui-selected": {
    bgcolor: ACTIVE_BG,
    color: "primary.main",
    "& .MuiListItemIcon-root": { color: "primary.main" },
    "& .MuiListItemText-primary": { fontWeight: 600 },
  },
  "&.Mui-selected:hover": { bgcolor: ACTIVE_BG_HOVER },
  "&.Mui-disabled": { opacity: 0.55 },
};

/** Group header colours when the current page is inside that group. */
export const activeGroupSx = {
  color: "primary.main",
  "& .MuiListItemIcon-root": { color: "primary.main" },
};

/** A square icon button in the collapsed rail. */
export const railButtonSx = (active: boolean) => ({
  justifyContent: "center",
  minHeight: 44,
  mx: 1,
  my: 0.25,
  borderRadius: 2,
  color: active ? "primary.main" : ICON,
  bgcolor: active ? ACTIVE_BG : "transparent",
  "& .MuiSvgIcon-root": { fontSize: 22 },
  "&:hover": { bgcolor: active ? ACTIVE_BG_HOVER : HOVER_BG },
});
